/* eslint-disable no-restricted-globals */
/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState } from 'react';
import { Container, Row, Spinner } from 'reactstrap';
import './loading.css';

export const LoadingContext = createContext({});

function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);

  const loadingWithTime = (duration) => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, duration);
  };

  const toggleLoading = () => {
    setLoading((prevState) => !prevState);
  };

  return (
    <LoadingContext.Provider
      value={{
        loading,
        setLoading,
        loadingWithTime,
        toggleLoading,
      }}
    >
      {loading && (
        <Container fluid className="loading">
          <Row>
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Spinner color="primary" type="grow">
                  {' '}
                  Loading...{' '}
                </Spinner>
              </div>
            </div>
          </Row>
        </Container>
      )}
      {children}
    </LoadingContext.Provider>
  );
}

function useLoading() {
  const context = useContext(LoadingContext);

  return context;
}

export { LoadingProvider, useLoading };
